import { debug } from '../helpers';

const SCAN_FAIL_TIMEOUT = window?.edacpFullSiteScanApp?.scanFailTimeout || 15000;

export const scanFailTimer = {
	timer: null,
	start( postId ) {
		this.timer = setInterval( () => {
			debug( 'Scan took too long: ' + postId );
			dispatchEvent( new CustomEvent( 'edacp_scan_complete', {
				detail: {
					postId,
					violations: [],
					iframeId: 'iframe_' + postId,
					failed: true,
				},
			} ) );
		}, SCAN_FAIL_TIMEOUT );
	},
	stop() {
		clearInterval( this.timer );
	},
};
